!function webpackUniversalModuleDefinition(e, r) {
  "object" == typeof exports && "object" == typeof module ? module.exports = r() : "function" == typeof define && define.amd ? define([], r) : "object" == typeof exports ? exports["@wordpress/is-shallow-equal"] = r() : (e.wp = e.wp || {}, e.wp.isShallowEqual = r());
}(self, function () {
  return function () {
    var e = {
      424: function _(e) {
        e.exports = function _interopRequireDefault(e) {
          return e && e.__esModule ? e : {
            default: e
          };
        }, e.exports.__esModule = !0, e.exports.default = e.exports;
      },
      249: function _(e, r) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.default = function isShallowEqualArrays(e, r) {
          if (e === r) return !0;
          if (e.length !== r.length) return !1;

          for (var _t = 0, u = e.length; _t < u; _t++) {
            if (e[_t] !== r[_t]) return !1;
          }

          return !0;
        };
      },
      471: function _(e, r) {
        "use strict";

        Object.defineProperty(r, "__esModule", {
          value: !0
        }), r.default = function isShallowEqualObjects(e, r) {
          if (e === r) return !0;
          var t = Object.keys(e),
              u = Object.keys(r);
          if (t.length !== u.length) return !1;
          var n = 0;

          for (; n < t.length;) {
            var _u = t[n],
                o = e[_u];
            if (void 0 === o && !r.hasOwnProperty(_u) || o !== r[_u]) return !1;
            n++;
          }

          return !0;
        };
      }
    },
        r = {};

    function __webpack_require__(t) {
      var u = r[t];
      if (void 0 !== u) return u.exports;
      var n = r[t] = {
        exports: {}
      };
      return e[t](n, n.exports, __webpack_require__), n.exports;
    }

    var t = {};
    return function () {
      "use strict";

      var e = t,
          r = __webpack_require__(424);

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.default = function isShallowEqual(e, r) {
        if (e && r) {
          if (e.constructor === Object && r.constructor === Object) return (0, u.default)(e, r);
          if (Array.isArray(e) && Array.isArray(r)) return (0, n.default)(e, r);
        }

        return e === r;
      }, Object.defineProperty(e, "isShallowEqualArrays", {
        enumerable: !0,
        get: function get() {
          return n.default;
        }
      }), Object.defineProperty(e, "isShallowEqualObjects", {
        enumerable: !0,
        get: function get() {
          return u.default;
        }
      });
      var u = r(__webpack_require__(471)),
          n = r(__webpack_require__(249));
    }(), t;
  }();
});